import React from "react";
import { Helmet } from "react-helmet";

export default function OptinMonster() {
  
  return (
      <Helmet>
        <script type='text/javascript' src='https://a.omappapi.com/app/js/api.min.js' async={true} data-user={132797} data-account={145332} />
      </Helmet>
  )
};
